import { render, staticRenderFns } from "./Dumbapps.vue?vue&type=template&id=7c58fcf2&"
import script from "./Dumbapps.vue?vue&type=script&lang=js&"
export * from "./Dumbapps.vue?vue&type=script&lang=js&"
import style0 from "./Dumbapps.vue?vue&type=style&index=0&id=7c58fcf2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports